import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import apiClient, { getErrorMessage } from '../../api/client';
import { useToast } from '../../hooks/useToast';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const PlatformWebhookEvents = () => {
  const { error: showError } = useToast();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    apiClient.get('/subscriptions/webhook-events')
      .then(({ data }) => setEvents(data.data))
      .catch((err) => showError(getErrorMessage(err, 'Could not load webhook events')))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const formatPayload = (payload) => {
    try {
      return JSON.stringify(JSON.parse(payload), null, 2);
    } catch {
      return payload;
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.5rem' }}>Webhook Events</h1>
        <p style={{ color: '#6b7280', margin: '0.25rem 0 0 0' }}>
          Raw payment-provider callbacks received by the platform
        </p>
      </div>

      <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '8px', padding: '1rem', marginBottom: '1.5rem', color: '#92400e', fontSize: '0.85rem' }}>
        ⚠️ This environment has no live payment provider connected — nothing verifies a real
        signature or automatically processes these events into a subscription/payment state
        change. Every event genuinely shown here is exactly what was received, unprocessed,
        which is why "Processed" will always read No.
      </div>

      <div className="table-container" style={{ background: 'white', borderRadius: '8px', overflow: 'hidden' }}>
        <table className="data-table">
          <thead><tr><th>Received</th><th>Integration</th><th>Event Type</th><th>Processed</th><th></th></tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: '2rem' }}>Loading...</td></tr>
            ) : events.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>No webhook events received yet</td></tr>
            ) : events.map((e) => (
              <React.Fragment key={e.id}>
                <tr style={{ cursor: 'pointer' }} onClick={() => setExpandedId(expandedId === e.id ? null : e.id)}>
                  <td>{new Date(e.receivedAt).toLocaleString()}</td>
                  <td style={{ fontFamily: 'monospace' }}>{e.integrationCode}</td>
                  <td>{e.eventType}</td>
                  <td>
                    <span className="badge" style={{ background: e.processed ? '#10b981' : '#9ca3af', color: 'white' }}>
                      {e.processed ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td>{expandedId === e.id ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}</td>
                </tr>
                {expandedId === e.id && (
                  <tr>
                    <td colSpan={5} style={{ background: '#f9fafb', padding: '1rem' }}>
                      <pre style={{ margin: 0, fontSize: '0.8rem', overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
                        {formatPayload(e.payload)}
                      </pre>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </motion.div>
  );
};

export default PlatformWebhookEvents;